import { createFileRoute } from "@tanstack/react-router";
import { ImageStudioPage } from "../../features/ai/image-studio-page";

export const Route = createFileRoute("/restaurants/$restaurantId_/images")({
	component: Page,
});

function Page() {
	const { restaurantId } = Route.useParams();
	return <ImageStudioPage key={restaurantId} restaurantId={restaurantId} />;
}
